(function () {
  'use strict';
  if (window.AquonCheckout) return;

  var config = window.AquonCheckoutConfig || {};
  var strings = config.strings || {};
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var pending = null;
  var activeSession = null;
  var lastCartIntent = 0;
  var sdkFailed = false;
  var buttonStates = new Map();
  var inertStates = new Map();

  function say(key) {
    var status = document.getElementById('AquonCheckoutStatus');
    if (status) status.textContent = strings[key] || '';
  }

  function nativeCheckout() {
    say('redirecting');
    window.location.assign(root + 'checkout');
    return { provider: 'shopify' };
  }

  function setBusy(busy) {
    document.documentElement.toggleAttribute('data-aquon-checkout-busy', busy);
    if (busy) {
      document.querySelectorAll('cart-items-component .cart-items__wrapper').forEach(function (control) {
        inertStates.set(control, control.inert);
        control.inert = true;
      });
      document.querySelectorAll('[data-aquon-checkout]').forEach(function (button) {
        var label = button.querySelector('[data-checkout-label]');
        buttonStates.set(button, { disabled: button.disabled, text: label && label.textContent });
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        if (label) label.textContent = strings.opening || 'Opening checkout…';
      });
    } else {
      buttonStates.forEach(function (state, button) {
        button.disabled = state.disabled;
        button.removeAttribute('aria-busy');
        var label = button.querySelector('[data-checkout-label]');
        if (label) label.textContent = state.text;
      });
      buttonStates.clear();
      inertStates.forEach(function (inert, control) { control.inert = inert; });
      inertStates.clear();
      if (activeSession && activeSession.opened && checkoutFrame()) activeSession.lockBackground();
    }
  }

  function visibleFocusTarget(node) {
    return node && node.isConnected && !node.disabled && !node.closest('[hidden], [inert]') && node.getClientRects().length;
  }

  function restoreFocus(preferred) {
    var target = visibleFocusTarget(preferred) ? preferred : Array.from(document.querySelectorAll('[data-apdp-atc], [on\\:click="cart-drawer-component/open"], a[href$="/cart"]')).find(visibleFocusTarget);
    if (visibleFocusTarget(target)) target.focus({ preventScroll: true });
  }

  function showRecovery(message, target) {
    var panel = document.getElementById('AquonCheckoutRecovery');
    if (!panel) return;
    var text = panel.querySelector('[data-checkout-error]');
    if (text) text.textContent = message;
    panel.hidden = false;
    panel.returnFocus = target;
    panel.focus({ preventScroll: true });
  }

  function clearRecovery() {
    var panel = document.getElementById('AquonCheckoutRecovery');
    if (panel && !panel.hidden) panel.hidden = true;
  }

  function waitUntil(predicate, timeout) {
    return new Promise(function (resolve) {
      var started = Date.now();
      function check() {
        if (predicate()) return resolve(true);
        if (Date.now() - started >= timeout) return resolve(false);
        setTimeout(check, 50);
      }
      check();
    });
  }

  function sdkReady() {
    return !!(window.HeadlessCheckout && typeof window.HeadlessCheckout.checkout === 'function' && typeof window.shiprocketCheckoutBuyCartHandler === 'function');
  }

  async function cartReady() {
    if (window.AquonPurchase && window.AquonPurchase.whenIdle) await window.AquonPurchase.whenIdle();
    var ready = await waitUntil(function () {
      return Date.now() - lastCartIntent >= 400 && !document.querySelector('.cart-items-disabled');
    }, 10000);
    if (!ready) throw new Error(strings.cart_updating || 'Your cart is still updating. Please try again.');
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 10000);
    try {
      var response = await fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: controller.signal, cache: 'no-store' });
      if (!response.ok) throw new Error();
      var cart = await response.json();
      if (!cart.item_count) throw new Error(strings.empty_cart || 'Your cart is empty. Choose a pack to continue.');
      return cart;
    } catch (error) {
      throw new Error(error.message && error.message === strings.empty_cart ? error.message : strings.cart_error || 'We could not check your cart. Please try again.');
    } finally {
      clearTimeout(timer);
    }
  }

  async function closeThemeDialogs() {
    var dialogs = Array.from(document.querySelectorAll('dialog[open]'));
    for (var dialog of dialogs) {
      var component = dialog.parentElement;
      while (component && typeof component.closeDialog !== 'function') component = component.parentElement;
      if (component) await component.closeDialog();
      else dialog.close();
    }
  }

  function checkoutFrame() {
    return document.getElementById('headless-iframe');
  }

  function watchSession(target) {
    var session = { target: target, bodyOverflow: document.body.style.overflow, bodyHeight: document.body.style.height, opened: false, closed: false };
    var previousCallback = window.srCustomCheckoutCallBackFn;
    var hadOpenClass = document.documentElement.classList.contains('aquon-checkout-open');
    var backgroundStates = new Map();
    var focusedFrame = null;
    var observer;
    function razorpayFrame(container) {
      // Shiprocket can open Razorpay's standard checkout in the parent page.
      // Only its verified container + HTTPS checkout iframe may escape inert;
      // a payment-looking class or an unrelated iframe alone is insufficient.
      if (!container.classList.contains('razorpay-container') || container.hidden || container.style.display === 'none') return null;
      return Array.from(container.children).find(function (frame) {
        if (!frame.matches('iframe.razorpay-checkout-frame') || !frame.getClientRects().length) return false;
        try {
          var url = new URL(frame.getAttribute('src'));
          return url.origin === 'https://api.razorpay.com' && url.pathname === '/v1/checkout/public' && !url.username && !url.password;
        } catch (error) {
          return false;
        }
      }) || null;
    }
    function lockBackground() {
      var vendorRoots = ['fastrr-main-container', 'headless-container', 'headless-payment-iframe'].map(function (id) {
        return document.getElementById(id);
      }).filter(Boolean);
      var gatewayFrame = null;
      Array.from(document.body.children).forEach(function (child) {
        var paymentFrame = razorpayFrame(child);
        var containsCheckout = paymentFrame || vendorRoots.some(function (node) { return child === node || child.contains(node); });
        if (paymentFrame) gatewayFrame = paymentFrame;
        if (containsCheckout) {
          // A vendor container can be moved beneath a previously locked child.
          if (backgroundStates.has(child)) {
            child.inert = backgroundStates.get(child);
            backgroundStates.delete(child);
          }
          return;
        }
        if (!backgroundStates.has(child)) backgroundStates.set(child, inertStates.has(child) ? inertStates.get(child) : child.inert);
        child.inert = true;
      });
      document.documentElement.classList.add('aquon-checkout-open');
      return gatewayFrame;
    }
    function finish(returnFocus) {
      if (session.closed) return;
      session.closed = true;
      if (observer) observer.disconnect();
      if (window.srCustomCheckoutCallBackFn === onClose) window.srCustomCheckoutCallBackFn = previousCallback;
      if (activeSession === session) activeSession = null;
      backgroundStates.forEach(function (inert, node) { node.inert = inert; });
      backgroundStates.clear();
      if (!hadOpenClass) document.documentElement.classList.remove('aquon-checkout-open');
      document.body.style.overflow = session.bodyOverflow;
      document.body.style.height = session.bodyHeight;
      say('');
      if (returnFocus !== false) requestAnimationFrame(function () { restoreFocus(target); });
    }
    function onClose(event) {
      try { if (typeof previousCallback === 'function') previousCallback(event); }
      finally { if (event && event.event === 'sr-headless-close') finish(); }
    }
    session.finish = finish;
    session.lockBackground = lockBackground;
    window.srCustomCheckoutCallBackFn = onClose;
    observer = new MutationObserver(function () {
      var frame = checkoutFrame();
      if (frame) {
        session.opened = true;
        clearRecovery();
        if (!frame.title) frame.title = strings.frame_title || 'Secure checkout';
        var paymentFrame = lockBackground();
        var focusFrame = paymentFrame || frame;
        if (!focusFrame.title) focusFrame.title = strings.frame_title || 'Secure checkout';
        if (focusedFrame !== focusFrame) {
          focusedFrame = focusFrame;
          focusFrame.focus({ preventScroll: true });
        }
      } else if (session.opened) {
        finish();
      }
    });
    // Razorpay reuses a preloaded container and toggles its display on open/close.
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'src', 'hidden'] });
    return session;
  }

  function start(options) {
    options = options || {};
    if (pending) return pending;
    if (activeSession) {
      if (checkoutFrame()) return Promise.resolve({ provider: 'shiprocket' });
      // The SDK's existing-cart API has no cancellation handle. Keep observing a
      // slow request and never issue another one while it may still open.
      var waitingError = new Error(strings.slow || 'Checkout is taking longer than expected. Your cart is saved.');
      waitingError.checkoutHandled = true;
      showRecovery(waitingError.message, activeSession.target);
      return Promise.reject(waitingError);
    }
    clearRecovery();
    var trigger = options.returnFocus || options.trigger || document.activeElement;
    setBusy(true);
    say('opening');
    pending = (async function () {
      await cartReady();
      await closeThemeDialogs();
      if (config.provider !== 'shiprocket') return nativeCheckout();
      var ready = sdkReady() || (!sdkFailed && await waitUntil(function () { return sdkReady() || sdkFailed; }, 5000) && sdkReady());
      if (!ready) return nativeCheckout();
      activeSession = watchSession(trigger);
      var session = activeSession;
      try {
        window.HeadlessCheckout.checkout(null);
      } catch (error) {
        session.finish(false);
        return nativeCheckout();
      }
      var opened = await waitUntil(function () { return !!checkoutFrame() || session.opened || session.closed; }, 12000);
      if (opened) {
        session.opened = true;
        return { provider: 'shiprocket' };
      }
      // Leave the observer and callback attached: the vendor request cannot be
      // aborted, and a late iframe still needs focus, inert and close handling.
      throw new Error(strings.slow || 'Checkout is taking longer than expected. Your cart is saved.');
    })().catch(async function (error) {
      await closeThemeDialogs();
      if (!checkoutFrame()) showRecovery(error.message || strings.cart_error, trigger);
      error.checkoutHandled = true;
      throw error;
    }).finally(function () {
      pending = null;
      setBusy(false);
      say('');
    });
    return pending;
  }

  document.addEventListener('quantity-selector:update', function (event) {
    if (event.target.closest('cart-items-component')) lastCartIntent = Date.now();
  }, true);
  document.addEventListener('click', function (event) {
    if (pending && event.target.closest && event.target.closest('cart-items-component .cart-items__wrapper')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    var target = event.target.closest && event.target.closest('[data-aquon-checkout]');
    if (target) {
      event.preventDefault();
      if (!target.disabled && target.getAttribute('aria-disabled') !== 'true') start({ trigger: target }).catch(function () {});
    }
    var close = event.target.closest && event.target.closest('[data-checkout-dismiss]');
    if (close) {
      var panel = document.getElementById('AquonCheckoutRecovery');
      clearRecovery();
      restoreFocus(panel && panel.returnFocus);
    }
  }, true);
  document.addEventListener('submit', function (event) {
    if (event.submitter && event.submitter.matches('[data-aquon-checkout]')) {
      event.preventDefault();
      start({ trigger: event.submitter }).catch(function () {});
    }
  });
  var script = document.getElementById('AquonShiprocketSdk');
  if (script) script.addEventListener('error', function () { sdkFailed = true; });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) { pending = null; setBusy(false); clearRecovery(); }
  });
  window.AquonCheckout = { start: start };
})();
